import * as React from 'react';
import type { SVGProps } from 'react';

export type IllustrationSizeVariants =
  | 'small'
  | 'medium'
  | 'large'
  | 'xlarge'
  | 'xxlarge'
  | 'xxxlarge'
  | 'xxxxlarge';
export type IllustrationProps = {
  width?: number | string;
  height?: number | string;
  size?: IllustrationSizeVariants;
};
const IllustrationSpotTop = ({
  size = 'medium',
  width,
  height,
  ...props
}: IllustrationProps) => {
  let presetWidth: string | undefined;
  let presetHeight: string | undefined;
  const presets = {
    small: '48px',
    medium: '68px',
    large: '92px',
    xlarge: '122px',
    xxlarge: '156px',
    xxxlarge: '194px',
    xxxxlarge: '236px',
  };
  if (size) {
    presetWidth = presets[size];
    presetHeight = presets[size];
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 68 68"
      data-xds="IllustrationSpotTop"
      height={height || presetHeight}
      role="presentation"
      width={width || presetWidth}
      {...props}
    >
      <path
        fill="var(--xdlColorIllustrationBackground)"
        d="M33.56 50.45 13.05 65.34l7.83-24.1-20.5-14.9 25.34-.01 7.84-24.1 7.84 24.1 25.33.01-20.49 14.9 7.82 24.1z"
      />
      <path
        fill="#B7E854"
        d="M33.56 47.98 16.85 60.11l6.38-19.64-16.7-12.14h20.64L33.56 8.7l6.38 19.63h20.64L43.89 40.47l6.37 19.64z"
      />
      <path
        fill="var(--xdlColorIllustrationOutlinePrimary)"
        d="M51.21 61.41 33.56 48.59 15.91 61.41l6.73-20.75L4.99 27.83h21.82l6.75-20.75 6.75 20.75h21.82L44.48 40.67l6.73 20.75zM33.56 47.36 49.31 58.8 43.3 40.28l15.75-11.45H39.58l-6.02-18.52-6.02 18.51H8.07l15.75 11.45-6.01 18.52 15.75-11.44z"
      />
    </svg>
  );
};
export default IllustrationSpotTop;
